import { FieldBase } from '@/domain/mitarbeiter/features/anlageassistent/components/form/fieldComponents/FieldBase';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import {
  Feiertagsausgleich,
  feiertagsausgleich,
} from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/feiertagsausgleichRegelung';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function FeiertagsausgleichSelect() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();

  return (
    <form.AppField name="abwesenheiten.feiertagseinstellungen.feiertagsausgleich">
      {(field) => (
        <FieldBase
          label={t(
            'domain.mitarbeiter.create.steps.abwesenheiten.feiertagseinstellungen.form.feiertagsausgleich.label',
          )}>
          <Select
            value={field.state.value ?? ''}
            onValueChange={(e) => field.handleChange(e as Feiertagsausgleich)}>
            <SelectTrigger>
              <SelectValue
                onBlur={field.handleBlur}
                placeholder={t(
                  'domain.mitarbeiter.create.steps.abwesenheiten.feiertagseinstellungen.form.feiertagsausgleich.placeholder',
                )}
              />
            </SelectTrigger>
            <SelectContent>
              {Object.keys(feiertagsausgleich).map((key) => (
                <SelectItem key={key} value={key}>
                  {t(
                    'domain.mitarbeiter.create.steps.abwesenheiten.feiertagseinstellungen.form.feiertagsausgleich.options.' +
                      key,
                  )}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </FieldBase>
      )}
    </form.AppField>
  );
}
